<template>
  <div>
    <page-header>
      <div class="warning">警告:非开发人员请勿修改</div>
    </page-header>
    <div>
      <el-input type="textarea" v-model="json" :autosize="{minRows:20,maxRows:20}" resize="none"/>
    </div>
    <div style="margin-top: 24px">
      <el-button @click="modifyWechatMenu" type="primary">提交</el-button>
    </div>
  </div>
</template>

<script>
import api from "@/utils/api";
import PageHeader from "@/components/PageHeader";

export default {
  name: "WechatMenus",
  components: {PageHeader},
  data() {
    return {
      json: '{}'
    }
  },
  methods: {
    modifyWechatMenu() {
      this.$confirm("确定设置当前菜单吗?", '警告').then(confirm => {
        if (confirm !== 'confirm') {
          return;
        }
        api.clientSetting_modifyWechatMenu({
          json: this.json
        }).then(res => {
          if (res.data.code !== '000') {
            this.$message.error(res.data.message);
            return;
          }
          this.$message.success('修改成功');
        })
      });
    }
  }
}
</script>

<style scoped>
.warning {
  color: #ff0000;
  font-weight: bold;
  font-style: italic;
}
</style>
